import * as types from "../../constants";
import * as API from "../../services/APIService";
const route = "api/ChecklistUser/";

export function get() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLIST_USER_PENDING });
    return API.get(route)
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLIST_USER_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLIST_USER_ERROR });
        throw error;
      });
  };
}

export function insert(event) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_CHECKLIST_USER_PENDING });
    return API.insert(route, event)
      .then((response) => {
        dispatch({
          type: types.INSERT_CHECKLIST_USER_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_CHECKLIST_USER_ERROR });
        throw error;
      });
  };
}

export function update(event) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_CHECKLIST_USER_PENDING });
    return API.update(route, event)
      .then((response) => {
        dispatch({
          type: types.UPDATE_CHECKLIST_USER_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_CHECKLIST_USER_ERROR });
        throw error;
      });
  };
}

export function remove(event) {
  return async (dispatch) => {
    dispatch({ type: types.DELETE_CHECKLIST_USER_PENDING });
    return API.remove(route, event)
      .then((response) => {
        dispatch({
          type: types.DELETE_CHECKLIST_USER_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.DELETE_CHECKLIST_USER_ERROR });
        throw error;
      });
  };
}
